<template>
  <div class="wrapper">
    <!-- 展示长度条 -->
    <div
      class="bar"
      :style="{ background: barColor, width: width + '%' }"
    ></div>
    <!-- 展示文字 -->
    <div class="strength" :style="{ color: barColor, width: width + '%' }">
      {{ strength }}
    </div>
  </div>
</template>

<script>
import { level, checkPasswordRule } from "@/utils/checkPassword";
export default {
  data() {
    return {
      width: 0,
      barColor: "",
      strength: "",
    };
  },
  props: ["password"],
  methods: {
    watchPassword(newVal) {
      // this.$emit("getPass", newVal);
      if (newVal != "") {
        const res = level(newVal);
        if (res == "非常弱") {
          this.barColor = "red";
          this.width = "20";
          this.strength = "非常弱";
        } else if (res == "弱") {
          this.barColor = "#ee795c";
          this.width = "40";
          this.strength = "弱";
        } else if (res == "一般") {
          this.barColor = "orange";
          this.width = "60";
          this.strength = "一般";
        } else if (res == "强") {
          this.barColor = "green";
          this.width = "80";
          this.strength = "强";
        } else if (res == "非常强") {
          this.barColor = "#1B8EF8";
          this.width = "100";
          this.strength = "非常强";
        }
      }
    },
  },
  watch: {
    password: {
      handler(newVal) {
        this.watchPassword(newVal);
      },
    },
  },
  mounted() {
    this.watchPassword(this.password);
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  .bar {
    margin: 2px 0 5px 0;
    margin-top: 15px;
    max-width: 100%;
    height: 10px;
    background: red;
    transition: 0.5s all ease;
  }
  .strength {
    height: 28px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    color: #271e25;
    transition: 0.5s all ease;
  }
}
</style>